"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiterPerSecondPerKiloWatt = exports.GallonsPerMinutePerTonCooling = void 0;
var UnitDivide = require("../unit-divide");
var volume_flow_1 = require("./volume-flow");
var power_1 = require("./power");
// Volume flow per cooling power
exports.GallonsPerMinutePerTonCooling = UnitDivide.volumeFlowByPower("GallonsPerMinutePerTonCooling", volume_flow_1.GallonsPerMinute, power_1.TonCooling);
exports.LiterPerSecondPerKiloWatt = UnitDivide.volumeFlowByPower("LiterPerSecondPerKiloWatt", volume_flow_1.LiterPerSecond, power_1.KiloWatt);
//# sourceMappingURL=volume-flow-per-power.js.map